// @flow

declare var __API_URL__: string;

const rewriteUrl = (url: string) => (url ? url.replace(__API_URL__, '') : '');

export default rewriteUrl;
